import { EarningRuleGlobalLimitReward, POINT_RECORD_TYPE, recordListUserInfo } from 'config/CustomEnums';
import { POINT_TRANSACTION_TYPE } from 'containers/record/pointRecords/PointTransactionList';
import { getOnePointTransactionRecord, getPointGlobalSetting, getPointTransactionRecords, getPointTransactionReports } from 'services/TransactionRecordsAPIHelper';



import { loading } from './LoadingUtil';
import { parseTransactionDisplayType, transactionDisplayInvoiceIdAndId } from './TransactionModel';



import { convertCursorToNumber, convertNumberToCursor, createAction, formatNumberWithCommas } from 'utils';
import { capitalizeFirstLetter } from 'utils/StringUtil';
import { formatDate, getDetailPageDisplayLastModifiedDate, getDisplayDate, getListDisplayLastModifiedDate } from 'utils/TimeFormatUtil';
import { 
  getDisplayQuantityWithLimitInfo, 
  getCampaignDisplayName,
  getCampaignLink,
} from 'models/RecordUtils';
import { parseReachLimitInfo } from 'utils/ReachLimitInfoUtils';

function getDisplayTotalPoints(item) {
  return getDisplayQuantityWithLimitInfo(item, {
    rewardedQuantityField: 'loyaltyPoints',
    typeField: 'pointType',
    addTypeValue: 'TYPE_POINT_ADD',
    initialValueKeyInJson: 'points_value',
    unit: 'point',
    limitTypeValue: 'POINTS'
  });
}

function getInitState() {
  return {
    pointTransactionList: [],
    listDisplayFields: [
      { displayName: 'ID', fieldName: 'pk', linked: true },
      ...recordListUserInfo,
      { displayName: 'Event Type', fieldName: 'pointDisplayType' },
      { displayName: 'Gift card code', fieldName: 'giftCardCode' },
      { displayName: 'Points', fieldName: 'displayPoints', orderField: 'value' },
      { displayName: 'Loyalty Point', fieldName: 'loyaltyPoints', orderField: 'loyaltyPoints' },
      { displayName: 'Gift card Point', fieldName: 'giftCardPoints', orderField: 'giftCardPoints' },
      { displayName: 'Point source', fieldName: 'pointSource' },
      { displayName: 'Progression Points', fieldName: 'displayTpe' },
      { displayName: 'Record Type', fieldName: 'transactionDisplayType' },
      { displayName: 'Campaign', fieldName: 'displayCampaignName' },
      // { displayName: 'Remark', fieldName: 'remarks' },
      { displayName: 'Purchase date', fieldName: 'purchaseDate', orderField: "purchaseDate" },
      { displayName: 'Creation date', fieldName: 'creationDate', orderField: "pointRecordCreatedTime" },
    ],
    reportListDisplayFields: [
      { displayName: 'ID', fieldName: 'pk' },
      { displayName: 'Name', fieldName: 'name', linked: false },
      { displayName: 'Report type', fieldName: 'reportType' },
      { displayName: 'Time range', fieldName: 'displayTimeRange' },
      { displayName: 'Creation time', fieldName: 'creationDate' },
    ],
    pageInfo: {
      startCursor: '',
      endCursor: '',
      hasNextPage: false,
      hasPreviousPage: false,
    },
    currentLastCursor: '',
    currentPage: 0,
    totalPage: 0,
    totalCount: 0,
    checkedList: [],
    currentPagePointTransactionList: [],
    selectedPointTransaction: {},
    maxPointValue: 0,
    currentPagePointTransactionReportList: [],
    pointGlobalSetting: {},
  };
}

function parsePointTransactionType(transactionType) {
  switch (transactionType) {
    case 'CUSTOMER_EARN':
      return POINT_TRANSACTION_TYPE.CUSTOMER_EARN;
    case 'CUSTOMER_REDEEM_GIFT_CARD':
      return POINT_TRANSACTION_TYPE.CUSTOMER_REDEEM_GIFT_CARD;
    case 'CUSTOMER_USED':
      return POINT_TRANSACTION_TYPE.CUSTOMER_USED;
    case 'CUSTOMER_USED_CASH_DOLLAR':
      return POINT_TRANSACTION_TYPE.CUSTOMER_USED_CASH_DOLLAR;
    case 'CUSTOMER_USED_CASH_DOLLAR_BY_MERCHANT_SCANNING':
      return POINT_TRANSACTION_TYPE.CUSTOMER_USED_CASH_DOLLAR_BY_MERCHANT_SCANNING;
    case 'MERCHANT_USE_CASH_DOLLAR':
      return POINT_TRANSACTION_TYPE.MERCHANT_USE_CASH_DOLLAR;
    case 'ADMIN_EDITED':
      return POINT_TRANSACTION_TYPE.ADMIN_EDITED;
    case 'MERCHANT_EDITED':
      return POINT_TRANSACTION_TYPE.MERCHANT_EDITED;
    case 'EXPIRED':
      return POINT_TRANSACTION_TYPE.EXPIRED;
    case 'AUTO_ADMIN_EDITED':
      return POINT_TRANSACTION_TYPE.AUTO_ADMIN_EDITED;
    case 'AUTO_ADMIN_EDITED_CASH_DOLLAR':
      return POINT_TRANSACTION_TYPE.AUTO_ADMIN_EDITED_CASH_DOLLAR;
    case 'ADMIN_USE_CASH_DOLLAR':
      return POINT_TRANSACTION_TYPE.ADMIN_USE_CASH_DOLLAR;
    case 'ADMIN_TRANSFERRED':
      return POINT_TRANSACTION_TYPE.ADMIN_TRANSFERRED;
    default:
      break;
  }
}

function parsePointType(pointType) {
  switch (pointType) {
    case 'TYPE_POINT_ADD':
      return POINT_RECORD_TYPE.TYPE_ADD;
    case 'TYPE_POINT_REMOVE':
      return POINT_RECORD_TYPE.TYPE_REMOVE;
    default:
      break;
  }
}

function parsePointSource(pointSource) {
  switch (pointSource) {
    case 'LOYALTY':
      return 'Loyalty';
    case 'GIFT_CARD':
      return 'Gift card';
    case 'LOYALTY_AND_GIFT_CARD':
      return 'Loyalty and Gift card';
    default:
      return pointSource;
  }
}

function parsePointReportType(reportType) {
  switch (reportType) {
    case 'WEEKLY':
      return 'Weekly';
    case 'MONTHLY':
      return 'Monthly';
    default:
      break;
  }
}

function parsePointTransactionReport(item) {
  return {
    pk: item.pk,
    id: item.id,
    name: item.reportName,
    reportType: parsePointReportType(item.reportType),
    displayTimeRange: `${formatDate(
      item.startTime,
      'DD MMM yyyy',
    )} - ${formatDate(item.endTime, 'DD MMM yyyy')}`,
    creationDate: formatDate(item.creationDate, 'DD MMM yyyy'),
    reportFileUrl: item.reportFileUrl,
  };
}

const parsePointTransactionLinkedTransaction = (transaction) => {
  if (!transaction) {
    return {};
  }
  const transactionType = transaction?.transactionType;
  return {
    pk: transaction?.pk,
    transactionType,
    transactionDisplayType: parseTransactionDisplayType(
      transaction.transactionType,
    ),
    posInvoiceId: transaction?.posInvoiceId,
    invoiceId: transaction?.invoiceId,
    totalValue: transaction.totalValue,
    displayTotalValue: transaction.totalValue
      ? `HK$ ${formatNumberWithCommas(transaction.totalValue)}`
      : '',
    paidAmount: transaction.paidAmount,
    displayPaidAmount: transaction.paidAmount
      ? `HK$ ${formatNumberWithCommas(transaction.paidAmount)}`
      : '',
    transactionDetailDisplayDate: getDetailPageDisplayLastModifiedDate(
      transaction.date,
    ),
    transactionDisplayInvoiceInfo: transactionDisplayInvoiceIdAndId(transaction),
    detailDisplayPurchaseDate: getDetailPageDisplayLastModifiedDate(
      transaction.purchasedDate
    ),
  };
};


const getCustomerDisplayName = (customer, displayNickNameIfExist = true) => {
  if (!customer) {
    return null;
  }
  let displayNickName = '';

  if (displayNickNameIfExist && customer?.nickname) {
    displayNickName = `(${customer.nickname})`;
  }
  if (customer?.firstName && customer?.lastName) {
    return `${customer.firstName} ${customer.lastName} ${displayNickName}`;
  } else if (customer?.firstName) {
    return `${customer.firstName} ${displayNickName}`;
  } else if (customer?.lastName) {
    return `${customer.lastName} ${displayNickName}`;
  }
  return '';
};

function parsePointTransactionRecord(item) {
  const points = item.value;
  const originalPoints = item.originalValue;
  let displayPoints = points;
  let displayDetailPoints = points;
  // eslint-disable-next-line eqeqeq
  if (originalPoints && originalPoints !== "0" && points != originalPoints) {
    displayPoints = `${points} \n(${originalPoints})`;
    displayDetailPoints = `${points} (original: ${originalPoints})`;
  };

  const tpe = item.tpe;
  const originalTpe = item.originalTpe;
  let displayTpe = tpe;
  let displayDetailTpe = tpe;
  // eslint-disable-next-line eqeqeq
  if (originalTpe && originalTpe !== "0" && tpe != originalTpe) {
    displayTpe = `${tpe} \n(${originalTpe})`;
    displayDetailTpe = `${tpe} (original: ${originalTpe})`;
  };

  return {
    pk: item.pk,
    id: item.id,
    customerId: item.customer?.pk,
    membershipId: item.customer?.membershipId,
    mobilePhoneNumber: item.customer?.mobilePhoneNumberSubscriberNumber
    ? `+${item.customer.mobilePhoneNumberCountryCode}\r\n${item.customer.mobilePhoneNumberSubscriberNumber}` : null,
    email: item.customer?.emailAddress,
    customerIsRestricted: item.customer?.isReset || item.customer?.isTransferred,
    ssoUid: item.customer?.ssoUid,
    pointType: item.pointType,
    pointDisplayType: parsePointType(item.pointType),
    transactionType: item.transactionType,
    transactionDisplayType: parsePointTransactionType(item.transactionType),
    points,
    originalPoints,
    displayPoints,
    displayDetailPoints,
    giftCardCode: item.giftCardCodes?.join(', '),
    pointSource: parsePointSource(item.pointSource),
    giftCardPoints: item.giftCardPoints,
    loyaltyPoints: item.loyaltyPoints,
    tpe,
    originalTpe,
    displayTpe,
    displayDetailTpe,
    remarks: item.remarks,
    usedType: item.usedType,
    usedDisplayType: item.usedType
      ? capitalizeFirstLetter(item.usedType?.replace(/_/g, ' ').toLowerCase())
      : null,
    useDate: item.usedDate
      ? formatDate(item.usedDate, 'DD MMM yyyy (ddd), HH:mm a')
      : null,
    expiryDate: item.expireAtDate
      ? formatDate(item.expireAtDate, 'DD MMM yyyy (ddd), HH:mm a')
      : null,
    name: getCustomerDisplayName(item.customer),
    administratorName: item.administrator?.username,
    displayAdministrator: item.administrator?.pk
      ? `[ID: ${item.administrator?.pk}] ${item.administrator?.username}`
      : item.administrator?.username,
    customer: item.customer,
    createdDate: formatDate(item.pointRecordCreatedTime),
    expiredTime: formatDate(item.expireAtDate),
    source: item.transactionType,
    transaction: parsePointTransactionLinkedTransaction(item.transaction),
    reachLimit: item.reachLimit,
    pointsReachLimitInfo: parseReachLimitInfo(
      item.reachLimitInfo,
      item.allReachLimitInfo,
      EarningRuleGlobalLimitReward.POINTS
    ),
    ppReachLimitInfo : parseReachLimitInfo(
      item.reachLimitInfo,
      item.allReachLimitInfo,
      EarningRuleGlobalLimitReward.PROGRESSION_POINTS
    ),
    creationDate: getListDisplayLastModifiedDate(item.pointRecordCreatedTime),
    detailDisplayCreationDate: getDetailPageDisplayLastModifiedDate(item.pointRecordCreatedTime),
    purchaseDate: getListDisplayLastModifiedDate(item.purchaseDate),
    detailDisplayPurchaseDate: getDetailPageDisplayLastModifiedDate(item.purchasedDate),
    displayTotalPoints: getDisplayTotalPoints(item),
    displayCampaignName: getCampaignDisplayName(item?.campaign),
    campaign: item?.campaign,
    campaignLink: getCampaignLink(item?.campaign),
  };
}

export default {
  namespace: 'pointTransactionList',
  state: getInitState(),
  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    getCurrentPagePointRecords: [
      function* ({ payload }, { call, put }) {
        const { page } = payload;
        let afterCursor = undefined;
        if (page > 1) {
          afterCursor = btoa(`arrayconnection:${(page - 1) * 20 - 1}`);
        }
        const serviceArgs = [getPointTransactionRecords, afterCursor, payload];
        function* onSuccess(data) {
          const pointTransactionData = data.pointTransactions.edges;
          const pageInfo = data.pointTransactions.pageInfo;
          const totalCount = data.pointTransactions.totalCount;
          const currentLastCursor = pageInfo.endCursor;
          const pointTransactionList = pointTransactionData.map((item) =>
            parsePointTransactionRecord(item.node),
          );
          yield put(
            createAction('updateState')({
              currentPagePointTransactionList: pointTransactionList,
              pageInfo: {
                startCursor: convertCursorToNumber(pageInfo?.startCursor) + 1,
                endCursor: convertCursorToNumber(pageInfo?.endCursor) + 1,
              },
              currentLastCursor,
              totalCount,
              totalPage: Math.ceil(totalCount / 20),
              maxPointValue: data.pointTransactions.maxPointValue,
            }),
          );
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    getSinglePointRecord: [
      function* ({ payload }, { put }) {
        const { pointRecordPK } = payload;
        const pointRecordID = btoa(`PointTransactionNode:${pointRecordPK}`);
        const serviceArgs = [getOnePointTransactionRecord, pointRecordID];
        function* onSuccess(data) {
          const pointRecordData = data.pointTransaction;
          yield put(
            createAction('updateState')({
              selectedPointTransaction: parsePointTransactionRecord(
                pointRecordData,
              ),
            }),
          );
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    getCurrentPagePointReports: [
      function* ({ payload }, { call, put }) {
        const { page } = payload;
        let afterCursor = undefined;
        if (page > 1) {
          afterCursor = convertNumberToCursor((page - 1) * 20 - 1);
        }
        const serviceArgs = [getPointTransactionReports, afterCursor, payload];
        function* onSuccess(data) {
          const pointTransactionReportsData = data.pointReports.edges;
          const pageInfo = data.pointReports.pageInfo;
          const totalCount = data.pointReports.totalCount;
          const currentLastCursor = pageInfo.endCursor;
          const pointTransactionReportList = pointTransactionReportsData.map((item) =>
            parsePointTransactionReport(item.node),
          );
          yield put(
            createAction('updateState')({
              currentPagePointTransactionReportList: pointTransactionReportList,
              pageInfo: {
                startCursor: convertCursorToNumber(pageInfo?.startCursor) + 1,
                endCursor: convertCursorToNumber(pageInfo?.endCursor) + 1,
              },
              currentLastCursor,
              totalCount,
              totalPage: Math.ceil(totalCount / 20),
            }),
          );
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],

    getPointGlobalSetting: [
      function* ({ payload }, { call, select, put }) {
        const serviceArgs = [getPointGlobalSetting];
        function* onSuccess(data) {
          const pointGlobalSettingData = data?.pointGlobalSettings?.edges?.[0]?.node || {};
          yield put({
            type: 'updateState',
            payload: {
              pointGlobalSetting: {
                expiryRule: pointGlobalSettingData?.expiryRule,
                pointsValidityPeriod: pointGlobalSettingData?.pointsValidityPeriod,
              },
            },
          });
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
  },
};